import styled from 'styled-components';
import * as palette from '@mlc/mlc-palette';
import { ScreenSize } from '../../../enums';
import { Card as ToolkitCard, Heading } from '@mlc/web-ui-toolkit';

export const Card = styled(ToolkitCard)`
	background: ${palette.mlcBlack};
	background-position: top center;
	background-repeat: no-repeat;
	border: ${palette.mlcBlack};
	min-height: 130px;
	width: auto !important;

	@media (max-width: ${ScreenSize.medium}) {
		background: none;
		background-color: ${palette.mlcBlack};
		min-height: auto;
		padding: 15px;
	}
`;
